import store  from "../store";
import { useSelector } from "react-redux";
import moment from "moment";
import { isEmpty } from "lodash";

class Pendo {
  setData() {
    const colectedData = store.getState();
    const golferData = colectedData.golfer?.golfer;
    if (process.env.REACT_APP_PENDO_API_KEY)
      if (!isEmpty(golferData.first_name) && !isEmpty(golferData.last_name))
        this.initializePedo(colectedData);
  
  }

  setBody(data) {
    const golferData = this.generateGolferData(data);
    const joinClubData = this.generateJoinClubData(data);
    const membershipData = this.generateMembershipData(data);
    const addOnData = this.generateAddOnData(data);
    const paymentData = this.generatePaymentData(data);
    
    const visitor = { 
      id: golferData.email,
      app: 'jr',
      ...golferData,
      ...joinClubData,
      ...membershipData,
      ...addOnData,
      ...paymentData
    };
    const account = {
      id: golferData.email,
      app: 'jr',
      ...golferData
    }
    ;
    return { visitor: visitor, account: account };
  }
  
  initializePedo(data) {
    try {
      if (window.pendo?.isReady())
        window.pendo.updateOptions(this.setBody(data));
      else window.pendo.initialize(this.setBody(data));
    } catch (e) {
      window.pendo.initialize(this.setBody(data));
    }
  }
  
  generateGolferData(data) {
    const golferData = data.golfer?.golfer;
    let golferInfo = {}
    if  (!isEmpty(golferData)){
      golferInfo = {
        ghin_number: golferData.id,
        email: golferData.email,
        first_name: golferData.first_name,
        last_name: golferData.last_name,
        gender: golferData.gender,
        phone: golferData.phone_number
      }
    }
    return golferInfo;
  }
  
  generateJoinClubData(data) {
    const clubData = data.club?.club_data;
    let clubInfo = {};
    if  (!isEmpty(clubData)){
      clubInfo = {
        club_id: clubData.id,
        club_name: clubData.name
      }
    }
    return clubInfo;
  }
  
  generateMembershipData(data) {
    const membershipData = data.membership?.selected_membership;
    const membershipsData = data.membership?.memberships;
    let membershipInfo = {}
    if  (!isEmpty(membershipData) && !isEmpty(membershipsData)){
      const selectedM = Object.values(membershipsData).filter((e) => e.id === membershipData.id)[0];
      if (!isEmpty(selectedM))
        membershipInfo = {
          club_membership_id: selectedM.id,
          club_membership_name: selectedM.name,
          club_membership_description: selectedM.description,
          club_membership_fees_amount: selectedM.amount,
          club_membership_transaction_fee: selectedM.transaction_fee  
        };
    }
    return membershipInfo;
  }
  
  generateAddOnData(data) {
    const addonData = data.addons?.selected_addons;
    let addonInfo = {};
    if  (!isEmpty(addonData)){
      addonInfo = {};
      Object.values(addonData).forEach( (el, index) => {
        const key = `add_on_${index+1}`;
        addonInfo[`${key}_id`] = el.id;
        addonInfo[`${key}_name`] = el.name;
        addonInfo[`${key}_description`] = el.description;
        addonInfo[`${key}_is_donation`] = el.is_donation;
        addonInfo[`${key}_is_multiple_options`] = el.is_multiple_options;
        addonInfo[`${key}_is_optional`] = el.is_optional;
        addonInfo[`${key}_amount`] = parseFloat(el.amount);
        ;
      })
      
    }
    return addonInfo;
  }
  
  generatePaymentData(data) {
    const paymentData = data.payment?.payment;
    let paymentInfo = { confirmed_payment: false };
    if (!isEmpty(paymentData))
      paymentInfo = { confirmed_payment: (!isEmpty(paymentData.confirmed_payment) ? false : paymentData.confirmed_payment)};
    return paymentInfo;
  }
  
}

export default new Pendo();
